export const onlineTimeMinSec = (seconds, trueVal) => {
    if (trueVal) {
        // let now = Math.ceil(new Date().getTime() / 1000)
        if(seconds == null){
            return '--'
        }
        let mins = Math.floor(seconds / 60)
        let sec = seconds % 60
        if(mins/60>1){
            let hours=Math.floor(mins/60)
            mins=mins%60
            return `${hours}小时${mins}分${sec}秒`
        }
        return `${mins}分${sec}秒`
    } else {
        return '--'
    }
}

export const onlineTimeSubtract = (seconds, trueVal) => {
    if (trueVal) {
        let now = Math.ceil(new Date().getTime() / 1000)
        if(seconds == null){
            return '--'
        }
        let mins = Math.floor((now - seconds) / 60)
        let sec = seconds % 60
        if(mins/60>1){
            let hours=Math.floor(mins/60)
            mins=mins%60
            return `${hours}小时${mins}分${sec}秒`
        }
        return `${mins}分${sec}秒`
    } else {
        return '--'
    }
}